import { Point } from '../utils/point';
import { LineTypeEnum } from '../../../../../enum/workbench/fabric-preview/line-type-enum';
import { MaterialThickness } from '../materials/material-thickness';
import { ShapeTypeEnum } from 'src/app/enum/workbench/shape-type.enum';

export class ConfigurationEdge {
  id?: string;
  startPoint?: Point;
  endPoint?: Point;
  length: number;
  /**
   * Côté du plan sur lequel se trouve le chant ('top' | 'bottom' | 'left' | 'right' | 'arc' | 'diagonal' | 'circle').
   * Persisté côté backend (colonne Side) pour fiabiliser le dédoublonnage. Si absent (legacy),
   * il est inféré depuis startPoint/endPoint via inferWorkbenchEdgeSide.
   */
  side?: string;

  planLength: number;
  planWidth: number;
  planDiameter: number;
  shapeType: ShapeTypeEnum;
  materialId: number;
  materialThicknessId: number;
  materialThickness: MaterialThickness;
  colorId: number;

  constructor(
    planLength: number,
    planWidth: number,
    shapeType: ShapeTypeEnum,
    startPoint: Point,
    endPoint: Point,
    colorId: number,
    materialId: number,
    materialThicknessId: number,
    lineType: LineTypeEnum,
    planDiameter: number = null
  ) {
    this.planLength = planLength;
    this.planWidth = planWidth;
    this.shapeType = shapeType;
    this.startPoint = startPoint;
    this.endPoint = endPoint;
    this.colorId = colorId;
    this.materialId = materialId;
    this.materialThicknessId = materialThicknessId;
    this.planDiameter = planDiameter;
    this.calculateLength(lineType);
  }

  private calculateLength(lineType: LineTypeEnum): void {
    this.length = 0;

    if (lineType == LineTypeEnum.straight) {
      const x = (this.endPoint.x - this.startPoint.x) ** 2;
      const y = (this.endPoint.y - this.startPoint.y) ** 2;
      this.length = Math.sqrt(x + y);
      if (this.shapeType == ShapeTypeEnum.HalfMoon || this.shapeType == ShapeTypeEnum.Mushroom) {
        if (this.length != this.planWidth) {
          this.length = Math.round(this.planLength);
        }
      }
      this.length = Math.round(Math.abs(this.length));
    } else if (lineType == LineTypeEnum.curve) {
      if (this.shapeType == ShapeTypeEnum.HalfMoon) {
        this.length = this.planWidth;
      } else if (this.shapeType == ShapeTypeEnum.Mushroom) {
        if (this.planDiameter == null || this.planDiameter <= 0) {
          throw new Error('diameter is null');
        }
        this.length = this.planDiameter;
      }
    }

    if (this.shapeType === ShapeTypeEnum.Circle) {
      if (this.planDiameter == null || this.planDiameter <= 0) {
        throw new Error('diameter is null');
      }
      this.length = this.planDiameter * 4;
    }
  }
}
